import { createSlice } from '@reduxjs/toolkit'
import { IsFlagDirectDebitStateType } from 'redux/type'

export const isFlagDirectDebitSlice: any = createSlice({
  name: 'isFlagDirectDebit',
  initialState: {
    isFlagDirectDebit: false
  },
  reducers: {
    setIsFlagDirectDebit: (
      state: IsFlagDirectDebitStateType,
      action: { payload: boolean }
    ): void => {
      state.isFlagDirectDebit = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const { setIsFlagDirectDebit } = isFlagDirectDebitSlice.actions

export default isFlagDirectDebitSlice.reducer
